import * as yup from 'yup';

export const ROLE_ADD_EDIT_SCHEMA = yup.object().shape({
    roleName: yup.string().required('Role name is required'),
    roleDescription: yup.string(),
    roleType: yup.string().required('Role type is required'),
    selectedOrganizations: yup.object(),
    selectedOrganization: yup.string(),
    permissions: yup
        .object()
        .test(
            'hasValidPermissions',
            'You must select at least one permission for the selected organization(s).',
            function (permissions) {
                const { roleType, selectedOrganizations, selectedOrganization } = this.parent;

                if (roleType === 'admin') {
                    return Object.entries(selectedOrganizations || {}).some(([orgId, isSelected]) => {
                        if (isSelected) {
                            const orgPermissions = permissions[orgId] || {};
                            return Object.values(orgPermissions).some(
                                (perm) => perm.read || perm.create || perm.update || perm.delete
                            );
                        }
                        return false;
                    });
                } else if (roleType === 'user') {
                    if (selectedOrganization) {
                        const orgPermissions = permissions[selectedOrganization] || {};
                        return Object.values(orgPermissions).some(
                            (perm) => perm.read || perm.create || perm.update || perm.delete
                        );
                    }
                    return false;
                }

                return true;
            }
        )
});
